module.exports = __webpack_public_path__ + "img/mobilenewsLogo2.a4f4e04d.png";